const FromArr = [{
		modelvalue: '',
		title: "产品线：",
		inputtype: "select",
		multiple: true,
		collapseTags: true,
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		modelvalue: '',
		title: "省份：",
		inputtype: "select",
		multiple: false,
		collapseTags: true,
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		modelvalue: '',
		title: "医院：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 50,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		modelvalue: '',
		title: "配送商类型：",
		inputtype: "select",
		multiple: false,
		collapseTags: true,
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 245,
		height: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		modelvalue: '',
		title: "配送商：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 22,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: '',
		title: "状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 28,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "时间：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "创建时间",
		widthLeft: 130,
		widthRight: 130,
		heightLeft: 32,
		heightRight: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}
];
export default FromArr;